import { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import TrustStrip from './components/TrustStrip';
import About from './components/About';
import WhatWeDo from './components/WhatWeDo';
import HowItWorks from './components/HowItWorks';
import Industries from './components/Industries';
import WhyBreakthru from './components/WhyBreakthru';
import CaseStudies from './components/CaseStudies';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <Hero />
      <TrustStrip />
      <About />
      <WhatWeDo />
      <HowItWorks />
      <Industries />
      <WhyBreakthru />
      <CaseStudies />
      <CTASection />
      <Footer />
    </div>
  );
}